
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Modal, Button } from "react-bootstrap";
import apiUrl from "../../environment/Api";

import { toast } from 'react-toastify';
import { Link } from "react-router-dom";



function Marketing_leads() {

    const [responseData, setResponseData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [isUpdateshowModal, setUpdateShowModal] = useState(false);

    const [isUpdatescheduleShowModal, setUpdatescheduleShowModal] = useState(false);
    const [responsesource, setResponsesource] = useState([]);
    const [responsepurpose, setResponsepurpose] = useState([]);
    const [category, setcategory] = useState([]);
    const [responseDatas, setResponseDatas] = useState([]);
    const [selected_category, setselected_category] = useState("");

    const [staff, setstaff] = useState('');
    const [role_id, setroleid] = useState('');

    const [previllages, setprevillages] = useState({})

    const [addData, setAddData] = useState({



        name: '',
        mobile_no: '',
        email: '',
        Enquiry_date: '',

        company: '',
        category: '',
        course_id: '',

        followups_status: '',

        from: '',
        to: '',
        travel_distance: '',
        visitor_staff: ''

    });



    const [updateData, setUpdateData] = useState({
        name: '',
        mobile_no: '',
        email: '',
        Enquiry_date: '',
        company: '',
        category: '',
        course_id: '',
        followups_status: '',
        from: '',
        to: '',
        travel_distance: '',
        visitor_staff: ''


    });




    const [updateDataschedule, setUpdateDataschedule] = useState({

        name: '',
        mobile_no: '',
        email: '',
        Enquiry_date: '',
        company: '',
        category: '',
        course_id: '',
        followups_status: '',
        from: '',
        to: '',
        travel_distance: '',
        visitor_staff: ''

    });



    useEffect(() => {
        fetchData();
        gettoken();
        fetch();
        fetchDa();
        Enquirypurpose();
        fetchDatag();

    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);



    const fetchData = async () => {
        try {
            const response = await axios.get(apiUrl + "/marketing_leads");
            console.log("Response from server:", response.data);
            console.log("Response from server:12345", response.data[0]?.course_id);
            setResponseData(response.data.reverse());
        } catch (error) {
            console.error("Error fetching data:", error.message);
        }
    };

    const fetchDatag = async () => {
        try {
            const response = await axios.get(apiUrl + "/staff");
            console.log("Response from server:", response.data);

            setstaff(response.data);
        } catch (error) {
            console.error("Error fetching data:", error.message);
        }
    };






    const fetchDa = async () => {
        try {

            const responsesources = await axios.get(apiUrl + "/source_type");
            console.log("Response from Source Type:", responsesources.data);
            setResponsesource(responsesources.data)
        } catch (error) {
            console.error("Error fetching data:", error.message);
        }
    };


    const Enquirypurpose = async () => {
        try {

            const responsepurposes = await axios.get(apiUrl + "/enquiry_purpose");
            console.log("Response from Enquiry purpose:", responsepurposes.data);

            setResponsepurpose(responsepurposes.data)
        } catch (error) {
            console.error("Error fetching data:", error.message);
        }
    };




    const fetch = async () => {
        try {
            const response = await axios.get(apiUrl + "/category_list");
            console.log("Response from server:", response.data);
            console.log("Response from category list :", category);
            setcategory(response.data);
        } catch (error) {
            console.error("Error fetching data:", error.message);
        }
    };




    const gettoken = async () => {
        const token = localStorage.getItem('token');
        // console.log("the toekn in the localStorage is : ",token);
        try {
            const response = await axios.post(apiUrl + "/get_detail", { "token": token });
            console.log("token detail from server:", response.data);
            // setResponseData(response.data);

            console.log("The role id is : ", response.data.detail.rolename);
            setroleid(response.data.detail.rolename);
            console.log("the role_id is : ", role_id);

            localStorage.setItem('role_id', response.data.detail.rolename);

            const id = response.data.detail.rolename

            // getpages();

            if (id) {
                try {
                    const response = await axios.get(apiUrl + `/role_2/${id}`);

                    console.log("the reponse list in brach is : ", response.data.modules);

                    const modules = response.data.modules;

                    const filtered_access = modules.filter(item => item.name == "Branch")

                    console.log("the modules is : ", filtered_access[0].actions);

                    setprevillages(filtered_access[0].actions);

                    console.log("the assigned previllages is : ", previllages.add);

                } catch (error) {
                    console.error("Error fetching data:", error.message);
                }
            }

        } catch (error) {
            console.error("Error fetching data:", error.message);
        }
    }



    const handlesubmit = async (e) => {
        e.preventDefault();


        try {
            const formData = {


                name: addData.name,
                mobile_no: addData.mobile_no,
                email: addData.email,
                Enquiry_date: addData.Enquiry_date,

                company: addData.company,
                category: addData.category,
                course_id: addData.course_id,

                followups_status: "New",
                from: addData.from,
                to: addData.to,
                travel_distance: addData.travel_distance,
                visitor_staff: addData.visitor_staff




            }
            const response = await axios.post(apiUrl + "/marketing_leads", formData);
            console.log("Updated:", response);
            setShowModal(false);
            toast.success("added successfully!");
            setAddData({
                name: ''
            });
            fetchData();
        } catch (error) {
            console.error("Error updating data:", error.message);
        }
    };


    const [updateid, setUpdateId] = useState("");

    const handleUpdate = (_id, data) => {
        if (previllages.edit || previllages.all) {
            setUpdateId(_id)
            console.log(" the data to updata   onclick data   ", data)
            console.log(" the data to updata   onclick course id   ", data.course_id)
            setUpdateShowModal(true);
            setUpdateData({


                name: data.name,
                mobile_no: data.mobile_no,
                email: data.email,
                Enquiry_date: data.Enquiry_date,
                company: data.company,
                category: data.category,
                course_id: data.course_id,
                followups_status: data.followups_status,
                from: data.from,
                to: data.to,
                travel_distance: data.travel_distance,
                visitor_staff: data.visitor_staff




            })



            // updateData.course_id = "00187"

            console.log(" the data to updata   onclick   12", updateData.course_id)
        } else {
            toast.error("You don't have the permission");
        }
    }








    // schedule update data 
    const [updateidschedule, setUpdateIdschedule] = useState("");


    const handlescheduleUpdate = (_id, data) => {

        setUpdateIdschedule(_id)
        console.log(" the data to updata", data)


        const courses = responseDatas.find(
            (item) => item.course_name === data.Prefered_course
        );
        console.log("the courserr12", courses);
        if (courses) {
            const coursedata = courses.category_list;
            console.log("the courserr12", courses);
            console.log("the course category_list", coursedata);

            // Set category data to state
            setUpdateDataschedule((prevData) => ({
                ...prevData,
                category: coursedata,
            }));

            setUpdateDataschedule((prevData) => ({
                ...prevData,               // Spread the previous state
                course_id: updateDataschedule.Prefered_course // Update only the course_id field
            }));

        } else {
            console.log("No matching course found for Prefered_course.");
        }

        console.log("filterUpdateData___category ", updateDataschedule.category);


        setUpdatescheduleShowModal(true);
        setUpdateDataschedule({


            name: data.name,
            mobile_no: data.mobile_no,
            email: data.email,
            Enquiry_date: data.Enquiry_date,
            company: data.company,
            category: data.category,
            course_id: data.course_id,
            followups_status: "new",
            from: data.from,
            to: data.to,
            travel_distance: data.travel_distance,
            visitor_staff: data.visitor_staff




        })

    }










    // Helper function to format ISO date to YYYY-MM-DD
    const formatDatefitching = (isoDate) => {
        if (!isoDate) return ""; // Return an empty string if no date is provided
        const date = new Date(isoDate);
        return date.toISOString().split("T")[0]; // Format as YYYY-MM-DD
    };


    const handleupdatesubmit = async (e) => {
        e.preventDefault();
        try {
            const formData = {


                name: updateData.name,
                mobile_no: updateData.mobile_no,
                email: updateData.email,
                Enquiry_date: updateData.Enquiry_date,

                company: updateData.company,
                category: updateData.category,
                course_id: updateData.course_id,
                followups_status: updateData.followups_status,
                from: updateData.from,
                to: updateData.to,
                travel_distance: updateData.travel_distance,
                visitor_staff: updateData.visitor_staff



            }
            console.log("the update submit data", formData)
            const response = await axios.put(apiUrl + `/marketing_leads/${updateid}`, formData)
            console.log("response for update", response)
            setUpdateShowModal(false)
            toast.success("Update successfully!");
            fetchData();
        }
        catch (error) {
            console.error("Error updating data:", error.message);
        }

    }



    // schedule

    const handleupdatesubmitschedule = async (e) => {
        e.preventDefault();

        setUpdateDataschedule((prevData) => ({
            ...prevData,               // Spread the previous state
            course_id: updateDataschedule.course_id // Update only the course_id field
        }));


        try {
            const formData = {


                student_name: updateDataschedule.name,
                mobile_no: updateDataschedule.mobile_no,
                email: updateDataschedule.email,
                Enquiry_date: updateDataschedule.Enquiry_date,
                company: updateDataschedule.company,
                category: updateDataschedule.category,
                Prefered_course: updateDataschedule.course_id,
                // status: updateDataschedule.status,
                followups_status: "Scheduled",


                from: updateDataschedule.from,
                to: updateDataschedule.to,
                travel_distance: updateDataschedule.travel_distance,
                visitor_staff: updateDataschedule.visitor_staff



            }
            console.log("the update schedule  submit data", formData)
            const response = await axios.post(apiUrl + `/leads`, formData)
            console.log("response for update", response)
            setUpdatescheduleShowModal(false)
            toast.success("Schedule post successfully!");


            fetchData();



        }
        catch (error) {
            console.error("Error updating data:", error.message);
        }

    }



    const handleDelete = async (id) => {
        try {

            const response = await axios.delete(apiUrl + `/marketing_leads/${getdeleteid}`)
            console.log("delete data ", response)
            toast.error("Delete successfully!");
            setDeleteShowModals(false);
            fetchData();
        }
        catch (error) {
            console.error("Error updating data:", error.message);
        }

    };


    const [deleteShowModals, setDeleteShowModals] = useState(false);
    const handleCloseModal = () => {
        setDeleteShowModals(false);
    }

    const [getdeleteid, setdeleteid] = useState('')
    const [getdeletename, setdeletename] = useState('')

    const handleOpenModal = (_id, name) => {

        if (previllages.all || previllages.delete) {
            console.log(" the id", _id)
            console.log(" the name", name)
            setdeleteid(_id);
            setdeletename(name);
            setDeleteShowModals(true);
        } else {
            toast.error("You don't have the permission");
        }
    }


    // the pagination ---------------------------------------------------------------------
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");
    // Pagination
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = responseData.slice(indexOfFirstItem, indexOfLastItem);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Search
    const filtered = currentItems.filter((item) =>
        Object.values(item).some(
            (value) =>
                typeof value === "string" &&
                value.toLowerCase().includes(searchQuery.toLowerCase()) ||
                (typeof value === "number" && value.toString().includes(searchQuery))
        )
    );

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
        setCurrentPage(1);
    };

    const totalPages = Math.ceil(responseData.length / itemsPerPage);

    const goToNextPage = () => {
        setCurrentPage((prevPage) =>
            prevPage === totalPages ? prevPage : prevPage + 1
        );
    };

    const goToPrevPage = () => {
        setCurrentPage((prevPage) => (prevPage === 1 ? prevPage : prevPage - 1));
    };
    // the pagination  end ---------------------------------------------------------------------


    const handleAdditionalChange = async (e) => {
        const selectcategory = e.target.value; // Get the selected value from the dropdown

        setselected_category(e.target.value)

        fetchDatas_2(e.target.value);
        console.log(
            "Additional change function called with value:",
            selectcategory
        );



    }


    useEffect(() => {
        fetchDatas();
    }, []);





    const fetchDatas = async (selected_category_2) => {
        try {
            const response = await axios.get(apiUrl + "/course");
            // const response = await axios.get(`apiUrl + "/category_course"+${category}`);
            // const response = await axios.get(`${apiUrl}/category_course${category}`);
            console.log("Response from server:123", response.data);
            console.log("Response from category list :", category);
            console.log("the selected_category is : ", selected_category_2)
            // if (response && response.data) {
            //   const data = response.data;

            setResponseDatas(response.data);
            // } else {
            //   console.error("No data received from server.");
            // }
        } catch (error) {
            console.error("Error fetching data:", error.message);
        }
    };

    const fetchDatas_2 = async (selected_category_2) => {
        try {
            const response = await axios.get(apiUrl + "/category_course/" + selected_category_2);
            // const response = await axios.get(`apiUrl + "/category_course"+${category}`);
            // const response = await axios.get(`${apiUrl}/category_course${category}`);
            console.log("Response from server:", response.data);
            // console.log("Response from category list :", category);
            // console.log("the selected_category is : ",selected_category_2)
            if (response && response.data) {
                const data = response.data;

                setResponseDatas(data);
            } else {
                console.error("No data received from server.");
            }
        } catch (error) {
            console.error("Error fetching data:", error.message);
        }
    };







    const getStatusLabelClass = (status) => {
        switch (status) {
            // case "Unqualified":
            //   return "bg-danger1 text-white1";
            // case "Reachable":
            //   return "bg-secondary1 text-white1";
            // case "converted":
            //   return "bg-warning1 text-black1"; // Assuming black text for "converted"
            // case "Reschedule":
            //   return "bg-primary1 text-white1";
            // case "Qualified":
            //   return "bg-success1 text-white1";
            // case "NotReachable":
            //   return "bg-dark1 text-white1";
            // case "Scheduled":
            //   return "bg-info1 text-white1";
            case "New":
                return "bg-info1 text-white1";
            // case "Walk-in-reschedule":
            //   return "bg-dark1 text-white1";
            default:
                return "";
        }
    };


    function handleChangeSatus(e) {
        const course = responseDatas.filter(
            (item, index) => item.course_id == e.target.value
        );
        console.log(course, "course---");
        setAddData({
            ...addData,
            course_id: e.target.value,
            selectcourse: course[0]?.course_name || "Course Not Found", // Fallback if no course is found
        });
    }



    const [selectedCourse, setSelectedCourse] = useState(updateData.Prefered_course || '');


    const [selectedCoursed, setSelectedCoursed] = useState(updateDataschedule.Prefered_course || '');

    // Handle the change event


    const handleCourseChange = (event) => {
        setSelectedCourse(event.target.value);
        setUpdateData({ ...updateData, Prefered_course: event.target.value });
    };


    // const handleCourseChangedd = (event) => {
    //     setSelectedCoursed(event.target.value);
    //     setUpdateDataschedule({ ...updateDataschedule, Prefered_course: event.target.value });
    // };


    const handleCourseChangedd = (e) => {
        setSelectedCoursed(e.target.value);
        setUpdateDataschedule({ ...updateDataschedule, Prefered_course: e.target.value });
    };







    const handleStaffChange = (e) => {
        setAddData({ ...addData, visitor_staff: e.target.value });
        setUpdateData({ ...updateData, visitor_staff: e.target.value });
    };







    return (
        <>




            <div className='top'>
                <div className="" style={{ marginTop: '-80px' }}>
                    <div className="row mb-3">
                        <div className="col-lg-11">
                            <Link to="/dashboard" className="text-secondary dashBoard_text">
                                <b>Dashboard / </b>
                            </Link>
                            <Link to="" className="text-danger dashBoard_text">
                                <b>Marketing leads</b>
                            </Link>
                            {/* <Link to="" className="text-danger dashBoard_text">
                            <b>Profile</b>
                        </Link> */}
                        </div>
                    </div>
                </div>
                {/* Table */}
                <div className='d-flex'>
                    <h5 className='mt-2'>Marketing Leads</h5>
                    <div className='mx-3'>
                        {previllages.add && (
                            <button
                                className="btn btn-success add mx-3"
                                onClick={() =>
                                    setShowModal(true)
                                }
                            >
                                Add
                            </button>
                        )}
                    </div>
                </div>

                {/* ------------ search and per page ----------------------------*/}

                <div className="mb-3 mt-3">
                    <div className="row">
                        <div className="col-lg-2 col-md-4 col-sm-4 d-flex">
                            <label className='form-label text-dark mt-2'>Show : </label>
                            <div>
                                <select className="form-control w-100 mx-2" onChange={(e) => { setItemsPerPage(e.target.value) }}>
                                    {/* <option value='5'>5</option> */}
                                    <option value='10'>10</option>
                                    <option value='20'>20</option>
                                    <option value='50'>50</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-lg-7 col-md-4 col-sm-1"></div>
                        <div className="col-lg-3 col-md-4 col-sm-7">

                            <div className="w-full flex-1">
                                <form>
                                    <div className="relative">

                                        <input
                                            className="form-control w-full bg-white  appearance-none pl-8  dark:bg-gray-950"
                                            placeholder="Search ..."
                                            type="search"
                                            value={searchQuery}
                                            onChange={handleSearchChange}
                                        />

                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                {/* --------------------------------end------------------------------------------- */}
                <div className='card'>
                    <div className="mt-1">
                        <table className="table table-striped "  >
                            <thead >
                                <tr>
                                    <th>S.No</th>
                                    <th>Name</th>
                                    <th>Company Name</th>
                                    <th>Mobile No</th>
                                    <th>Visit Date</th>
                                    <th>Status</th>
                                    <th className='text-center'>Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                {filtered.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{item.name}</td>
                                        <td>{item.company}</td>
                                        <td>{item.mobile_no}</td>
                                        <td>{formatDatefitching(item.Enquiry_date)}</td>

                                        <td>
                                            <p
                                                className={`text-center ${getStatusLabelClass(
                                                    item.followups_status
                                                )}`}
                                            >
                                                {item.followups_status}
                                            </p>
                                        </td>

                                        {/* 
                                        {(item.status == "Active") ?
                                            <td className='text-center hideres '>
                                                <p className=' text-white green-label' >{item.status}</p>
                                            </td>
                                            : <td className='text-center hideres'  ><p className='text-white red-label'>{item.status}</p></td>
                                        } */}


                                        <td className='text-center'>

                                            {/* <button className='btn updelete mx-2' onClick={() => handleUpdate(item._id, item)}><i class="fa-solid fa-pen-to-square"></i></button> */}

                                            {previllages.edit && (
                                                <button
                                                    className="btn updelete mx-2"
                                                    onClick={() => handleUpdate(item._id, item)}
                                                >
                                                    <i className="fa-solid fa-pen-to-square"></i>
                                                </button>
                                            )}




                                            {previllages.edit && (
                                                <button
                                                    className="btn updelete mx-2"
                                                    onClick={() => handlescheduleUpdate(item._id, item)}
                                                >
                                                    <i className="fa-solid fa-user-tag"></i>
                                                </button>
                                            )}



                                            {previllages.delete && (
                                                <button
                                                    className="btn delete"
                                                    onClick={() =>
                                                        handleOpenModal(item._id, item.name)
                                                    }
                                                >
                                                    <i className="fa-solid fa-trash-can"></i>
                                                </button>
                                            )}



                                            {/* <button className='btn delete'
                                                onClick={() => handleOpenModal(item._id, item.branch_name)}
                                            > <i class="fa-solid fa-trash-can"></i></button> */}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Modal for adding a new user */}
                <Modal show={showModal} onHide={() => setShowModal(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title id="modeti">Add Marketing Leads</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>


                        <div className='row'>
                            <div className='col-lg-6'>
                                <div className="form-group">

                                    <div className="floating-label">
                                        <input
                                            className="form-control"
                                            type="text"
                                            placeholder=''
                                            value={addData.name}
                                            onChange={(e) => setAddData({ ...addData, name: e.target.value })}
                                            required
                                        />
                                        <label className={addData.name ? "filled" : ""}>
                                            Name
                                        </label>

                                    </div>


                                    <div className="floating-label">
                                        <input
                                            className="form-control"
                                            type="text"
                                            placeholder=''
                                            value={addData.mobile_no}
                                            onChange={(e) => setAddData({ ...addData, mobile_no: e.target.value })}
                                            required
                                        />
                                        <label className={addData.mobile_no ? "filled" : ""}>
                                            Mobile No
                                        </label>

                                    </div>




                                    <div className="floating-label">
                                        <input
                                            className="form-control"
                                            type="Email"
                                            placeholder=''
                                            value={addData.email}
                                            onChange={(e) => setAddData({ ...addData, email: e.target.value })}
                                            required
                                        />
                                        <label className={addData.email ? "filled" : ""}>
                                            Email
                                        </label>

                                    </div>



                                    <div className="floating-label">
                                        <input
                                            className="form-control"
                                            type="date"
                                            placeholder=''
                                            value={addData.Enquiry_date}
                                            onChange={(e) => setAddData({ ...addData, Enquiry_date: e.target.value })}
                                            required
                                        />
                                        <label className={addData.Enquiry_date ? "filled" : ""}>
                                            Visit Date
                                        </label>

                                    </div>

                                   


                                    <div className="floating-label">
                                        {/* Select input for staff */}
                                        <select
                                            className="form-control"
                                            value={addData.visitor_staff}
                                            onChange={handleStaffChange}
                                            required
                                        >
                                            <option value="">Select Visitor Staff</option>
                                            { staff.length > 0 && staff.map((staffMember) => (
                                                <option key={staffMember.empid} value={staffMember.name}>
                                                    {staffMember.name} -  {staffMember.empid}
                                                </option>
                                            ))}
                                        </select>
                                        <label className={addData.visitor_staff ? "filled" : ""}>

                                        </label>
                                    </div>



                                    <div className="floating-label">
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder=''
                                        value={addData.company}
                                        onChange={(e) => setAddData({ ...addData, company: e.target.value })}
                                        required
                                    />
                                    <label className={addData.company ? "filled" : ""}>
                                        Company Name
                                    </label>

                                </div>




                                 











                                </div>
                            </div>
                            <div className='col-lg-6'>


                            <div className="floating-label">
                                        <input
                                            className="form-control"
                                            value={addData.from}
                                            onChange={(e) => setAddData({ ...addData, from: e.target.value })}
                                            required
                                        >

                                        </input>
                                        <label className={addData.from ? "filled" : ""}>
                                            From
                                        </label>
                                    </div>







                                <div className="floating-label">
                                    <input
                                        className="form-control"
                                        value={addData.to}
                                        onChange={(e) => setAddData({ ...addData, to: e.target.value })}
                                        placeholder=''
                                        required
                                    >

                                    </input>
                                    <label className={addData.to ? "filled" : ""}>
                                        To
                                    </label>
                                </div>



                                <div className="floating-label">
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder=''
                                        value={addData.travel_distance}
                                        onChange={(e) => setAddData({ ...addData, travel_distance: e.target.value })}
                                        required
                                    />
                                    <label className={addData.travel_distance ? "filled" : ""}>
                                        Travel Distance
                                    </label>

                                </div>


                                <div className="floating-label">
                                    <label className="form-label">
                                        <b></b>
                                    </label>
                                    <select
                                        className="form-select"
                                        value={addData.category}
                                        onChange={(e) => {
                                            const selectedCategory = e.target.value;
                                            // Update category
                                            setAddData({ ...addData, category: selectedCategory, course_id: "" }); // Reset course selection
                                            handleAdditionalChange(e); // Keep the additional change handler if required
                                        }}
                                        required
                                    >
                                        <option value="">Select Course Category</option>
                                        {category.map((item, index) => (
                                            <option key={index} value={item.category_name}>
                                                {item.category_name}
                                            </option>
                                        ))}
                                    </select>
                                    <label className={addData.category ? "filled" : ""}>

                                    </label>

                                </div>



                                {addData.category && (
                                    <div className="col-lg-12 mt-4">
                                        <div className="floating-label">
                                            <select
                                                className="form-select"
                                                value={addData.course_id}
                                                onChange={(e) => {
                                                    const selectedCourseId = e.target.value;
                                                    // Update course ID when a course is selected
                                                    setAddData({ ...addData, course_id: selectedCourseId });
                                                    handleChangeSatus(e); // Keep the status change handler if needed
                                                }}
                                                required
                                            >
                                                <option value="">Prefered Course</option>
                                                {/* Filter courses based on the selected category */}
                                                {responseDatas
                                                    .filter((item) => item.category_list === addData.category)
                                                    .map((item, index) => (
                                                        <option key={index} value={item.course_id}>
                                                            {item.course_id} - {item.course_name}
                                                        </option>
                                                    ))}
                                            </select>
                                            <label className={addData.course_id ? "filled" : ""}></label>
                                        </div>
                                    </div>
                                )}










                                {/* Status Select Dropdown */}
                                {/* <div className="floating-label">
                                    <select
                                        className="form-control"
                                        value={addData.status}
                                        placeholder='Select status'
                                        onChange={(e) => setAddData({ ...addData, status: e.target.value })}
                                    >
                                        <option value="">Select Status</option>
                                        <option value="Active">Active</option>
                                        <option value="Inactive">Inactive</option>
                                    </select>
                                    <label className={addData.status ? "filled" : ""}>
                                        Select Status
                                    </label>

                                </div> */}




                            </div>
                        </div>





                    </Modal.Body>

                    <Modal.Footer>
                        <Button className='cancelbut' variant="secondary" onClick={() => setShowModal(false)}>Cancel</Button>
                        <Button className='submitbut' variant="primary" onClick={handlesubmit}>Submit</Button>
                    </Modal.Footer>
                </Modal>


                <Modal show={isUpdateshowModal} onHide={() => setUpdateShowModal(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title id="modeti">Update Marketing leads</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>





                        <div className='row'>
                            <div className='col-lg-6'>
                                <div className="form-group">
                                    <div className="floating-label">
                                        <input className="form-control" type="text" placeholder='' value={updateData.name} onChange={(e) => setUpdateData({ ...updateData, name: e.target.value })} required />
                                        <label className={updateData.name ? "filled" : ""}>
                                            Name
                                        </label>
                                    </div>

                                    <div className="floating-label">
                                        <input className="form-control" type="text" placeholder='' value={updateData.mobile_no} onChange={(e) => setUpdateData({ ...updateData, mobile_no: e.target.value })} required />
                                        <label className={updateData.mobile_no ? "filled" : ""}>
                                            Mobile_no
                                        </label>
                                    </div>


                                    <div className="floating-label">
                                        <input className="form-control" type="text" placeholder='' value={updateData.email} onChange={(e) => setUpdateData({ ...updateData, email: e.target.value })} required />
                                        <label className={updateData.email ? "filled" : ""}>
                                            Email
                                        </label>
                                    </div>




                                    <div className="floating-label">
                                        <input
                                            className="form-control"
                                            type="date"
                                            placeholder=""
                                            value={
                                                updateData.Enquiry_date
                                                    ? formatDatefitching(updateData.Enquiry_date)

                                                    : ""
                                            }
                                            onChange={(e) =>
                                                setUpdateData({
                                                    ...updateData,
                                                    Enquiry_date: e.target.value,
                                                })
                                            }
                                            required
                                        />
                                        <label
                                            className={updateData.Enquiry_date ? "filled" : ""}
                                        >
                                            visit Date
                                        </label>
                                    </div>






                                    <div className="floating-label">
                                        {/* Select input for staff, same floating label structure */}
                                        <select
                                            className="form-control"
                                            value={updateData.visitor_staff}
                                            onChange={handleStaffChange}
                                            required
                                        >
                                            <option value="">Select Visitor Staff</option>
                                            {staff.length > 0 && staff.map((staffMember) => (
                                                <option key={staffMember.empid} value={staffMember.empid}>
                                                    {staffMember.name}
                                                </option>
                                            ))}
                                        </select>
                                        <label className={updateData.visitor_staff ? "filled" : ""}>

                                        </label>
                                    </div>





                                    <div className="floating-label">
                                        <input className="form-control" type="text" placeholder='' value={updateData.company} onChange={(e) => setUpdateData({ ...updateData, company: e.target.value })} required />
                                        <label className={updateData.company ? "filled" : ""}>
                                            Company Name
                                        </label>
                                    </div>






                                </div>
                            </div>
                            <div className='col-lg-6'>
                                <div className="form-group">





                                    <div className="floating-label">
                                        <input
                                            className="form-control"
                                            value={updateData.from}
                                            placeholder=''
                                            onChange={(e) => setUpdateData({ ...updateData, from: e.target.value })}
                                            required
                                        >
                                        </input>
                                        <label className={updateData.from ? "filled" : ""}>
                                            From
                                        </label>
                                    </div>





                                    <div className="floating-label">
                                        <input
                                            className="form-control"
                                            value={updateData.to}
                                            onChange={(e) => setUpdateData({ ...updateData, to: e.target.value })}
                                            placeholder=''
                                            required
                                        >

                                        </input>
                                        <label className={updateData.to ? "filled" : ""}>
                                            To
                                        </label>
                                    </div>




                                    <div className="floating-label">
                                        <input className="form-control" type="text" placeholder='' value={updateData.travel_distance} onChange={(e) => setUpdateData({ ...updateData, travel_distance: e.target.value })} required />
                                        <label className={updateData.travel_distance ? "filled" : ""}>
                                            Travel Distance
                                        </label>
                                    </div>



                                    <div className="floating-label">
                                        <label className="form-label">
                                            {/* <b>Category</b> */}
                                        </label>
                                        <select
                                            className="form-select"
                                            value={updateData.category}
                                            onChange={(e) =>
                                                setUpdateData({
                                                    ...updateData,
                                                    category: e.target.value,
                                                })
                                            }
                                            required
                                        >
                                            {category.map((item, index) => (
                                                <option key={index} value={item.category_name}>
                                                    {item.category_name}
                                                </option>
                                            ))}
                                        </select>
                                        <label className={updateData.category ? "filled" : ""}></label>
                                    </div>





                                    <div className="floating-label">

                                        <select
                                            className="form-select"
                                            value={updateData.course_id}  // Ensure this matches the value of one of the options
                                            onChange={(e) => handleCourseChange(e)}  // Handle changes if needed
                                            required
                                        >
                                            {responseDatas.map((item, index) => (
                                                <option key={index} value={item.course_id}>  {/* Set value as course_id */}
                                                    {item.course_id} - {item.course_name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>





                                    {/* <div className="floating-label">
                                        <label className="form-label">
                                
                                        </label>
                                        <select
                                            className="form-select"
                                            value={updateData.course_id}
                                            onChange={handleCourseChange}
                                            required
                                        >
                                            {responseDatas.map((item, index) => (
                                                <option key={index} value={item._id}>
                                                    {item.course_id} - {item.course_name}
                                                </option>
                                            ))}
                                        </select>

                                    </div> */}






                                    {/* <div className="floating-label">
                                        <input className="form-control" type="text" placeholder='' value={updateData.purpose_enquiry} onChange={(e) => setUpdateData({ ...updateData, purpose_enquiry: e.target.value })} required />
                                        <label className={updateData.purpose_enquiry ? "filled" : ""}>
                                            purpose Enquiry
                                        </label>
                                    </div> */}






                                </div>

                            </div>
                        </div>



                    </Modal.Body>

                    <Modal.Footer>
                        <Button className='cancelbut' variant="secondary" onClick={() => setUpdateShowModal(false)}>Cancel</Button>
                        <Button className='submitbut' variant="primary" onClick={handleupdatesubmit}>Update</Button>
                    </Modal.Footer>
                </Modal>



                {/* marketing leads schedule  =================================================================================*/}



                <Modal show={isUpdatescheduleShowModal} onHide={() => setUpdatescheduleShowModal(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title id="modeti"> Add Schedule Marketing leads</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>





                        <div className='row'>
                            <div className='col-lg-6'>
                                <div className="form-group">
                                    <div className="floating-label">
                                        <input className="form-control" type="text" placeholder='' value={updateDataschedule.name} onChange={(e) => setUpdateDataschedule({ ...updateDataschedule, name: e.target.value })} required />
                                        <label className={updateDataschedule.name ? "filled" : ""}>
                                            name
                                        </label>
                                    </div>

                                    <div className="floating-label">
                                        <input className="form-control" type="text" placeholder='' value={updateDataschedule.mobile_no} onChange={(e) => setUpdateDataschedule({ ...updateDataschedule, mobile_no: e.target.value })} required />
                                        <label className={updateDataschedule.mobile_no ? "filled" : ""}>
                                            Mobile_no
                                        </label>
                                    </div>


                                    <div className="floating-label">
                                        <input className="form-control" type="text" placeholder='' value={updateDataschedule.email} onChange={(e) => setUpdateDataschedule({ ...updateDataschedule, email: e.target.value })} required />
                                        <label className={updateDataschedule.email ? "filled" : ""}>
                                            Email
                                        </label>
                                    </div>




                                    <div className="floating-label">
                                        <input
                                            className="form-control"
                                            type="date"
                                            placeholder=""
                                            value={
                                                updateDataschedule.Enquiry_date
                                                    ? formatDatefitching(updateDataschedule.Enquiry_date)

                                                    : ""
                                            }
                                            onChange={(e) =>
                                                setUpdateDataschedule({
                                                    ...updateDataschedule,
                                                    Enquiry_date: e.target.value,
                                                })
                                            }
                                            required
                                        />
                                        <label
                                            className={updateDataschedule.Enquiry_date ? "filled" : ""}
                                        >
                                            Visit Date
                                        </label>
                                    </div>







                                </div>
                            </div>
                            <div className='col-lg-6'>
                                <div className="form-group">






                                    <div className="floating-label">
                                        <input className="form-control" type="text" placeholder='' value={updateDataschedule.company} onChange={(e) => setUpdateDataschedule({ ...updateDataschedule, company: e.target.value })} required />
                                        <label className={updateDataschedule.company ? "filled" : ""}>
                                            Company Name
                                        </label>
                                    </div>




                                    <div className="floating-label">
                                        <label className="form-label">
                                            {/* <b>Category</b> */}
                                        </label>
                                        <select
                                            className="form-select"
                                            value={updateDataschedule.category}
                                            onChange={(e) =>
                                                setUpdateDataschedule({
                                                    ...updateDataschedule,
                                                    category: e.target.value,
                                                })
                                            }
                                            required
                                        >
                                            {category.map((item, index) => (
                                                <option key={index} value={item.category_name}>
                                                    {item.category_name}
                                                </option>
                                            ))}
                                        </select>
                                        <label className={updateDataschedule.category ? "filled" : ""}></label>
                                    </div>






                                    {/* 
                                    <div className="floating-label">
                                        <label className="form-label">
                                       
                                        </label>
                                        <select
                                            className="form-select"
                                            value={updateDataschedule.Prefered_course}
                                            onChange={handleCourseChangedd}
                                            required
                                        >
                                            {responseDatas.map((item, index) => (
                                                <option key={index} value={item.course_name}>

                                                    {item.course_id} - {item.course_name}
                                                </option>
                                            ))}
                                        </select>

                                    </div>
 */}




                                    <div className="floating-label">

                                        <select
                                            className="form-select"
                                            value={updateDataschedule.course_id}  // Ensure this matches the value of one of the options
                                            onChange={(e) => handleCourseChangedd(e)}  // Handle changes if needed
                                            required
                                        >
                                            {responseDatas.map((item, index) => (
                                                <option key={index} value={item.course_id}>  {/* Set value as course_id */}
                                                    {item.course_id} - {item.course_name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>







                                    {/* <div className="floating-label">
                                        <select
                                            className="form-control"
                                            value={updateDataschedule.followups_status || ""}
                                            onChange={(e) =>
                                                setUpdateDataschedule({
                                                    ...updateDataschedule,
                                                    followups_status: e.target.value,
                                                })
                                            }
                                            required
                                        >
                                            <option value="">Select Followups Status</option>{" "}
                                    
                                            <option value="Rescheduled">Rescheduled</option>
                                            <option value="Qualified">Qualified</option>
                                            <option value="Unqualified">Unqualified</option>
                                            <option value="NotReachable">Not Reachable</option>
                                        </select>
                                        <label className={updateDataschedule.followups_status ? "filled" : ""}>

                                        </label>
                                    </div> */}





                                </div>

                            </div>
                        </div>



                    </Modal.Body>

                    <Modal.Footer>
                        <Button className='cancelbut' variant="secondary" onClick={() => setUpdatescheduleShowModal(false)}>Cancel</Button>
                        <Button className='submitbut' variant="primary" onClick={handleupdatesubmitschedule}>Sumbit</Button>
                    </Modal.Footer>
                </Modal>


                {/* ----------------delete */}

                <Modal className="modal" show={deleteShowModals} onHide={handleCloseModal}>
                    <Modal.Header>
                        <p id="modeti">Are you sure you want to Delete?</p>
                    </Modal.Header>
                    <Modal.Body>


                        <label className="form-label d-flex">
                            <h5 className='mx-1'>Name :</h5> <h5>{getdeletename} </h5>
                        </label>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className='cancelbut' variant="secondary" onClick={handleCloseModal}>
                            Close
                        </Button>
                        <Button className='submitbut' variant="primary" onClick={handleDelete} >Delete</Button>
                    </Modal.Footer>
                </Modal>
                {/* _------------------------------pagination button -------------------------------- */}


                <div className="mt-3 pb-5">
                    <div className="row">

                        <div className="col-lg-10 col-sm-12">
                            <nav className="d-flex float-right">
                                <ul className="pagination justify-content-center">
                                    <li
                                        className={` page-item ${currentPage === 1 ? "disabled" : ""
                                            }`}
                                    >
                                        <button className="page-link" onClick={goToPrevPage}>
                                            Previous
                                        </button>
                                    </li>
                                    {Array.from({ length: totalPages }, (_, i) => (
                                        <li
                                            key={i}
                                            className={`mx-2 page-item ${currentPage === i + 1 ? "active" : ""
                                                }`}
                                        >
                                            <button
                                                className="page-link "
                                                onClick={() => paginate(i + 1)}
                                            >
                                                {i + 1}
                                            </button>
                                        </li>
                                    ))}
                                    <li
                                        className={`page-item ${currentPage === totalPages ? "disabled" : ""
                                            }`}
                                    >
                                        <button className="page-link " onClick={goToNextPage}>
                                            Next
                                        </button>
                                    </li>
                                </ul>
                            </nav>{" "}
                        </div>
                        <div className="col-lg-2 col-sm-12 mt-1">
                            <div className="float-end">
                                <span className="text-dark ">
                                    Page {currentPage} of {totalPages}
                                </span>
                            </div>
                        </div>

                    </div>
                </div>


                {/* ---------------------------------------end ---------------------------------- */}


            </div>
        </>
    )
}

export default Marketing_leads;
